import { NavArrowUp } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconNavArrowUp12Line = createIcon(NavArrowUp, 12, "Line");
export const IconNavArrowUp16Line = createIcon(NavArrowUp, 16, "Line");
export const IconNavArrowUp20Line = createIcon(NavArrowUp, 20, "Line");
export const IconNavArrowUp24Line = createIcon(NavArrowUp, 24, "Line");
export const IconNavArrowUp32Line = createIcon(NavArrowUp, 32, "Line");
export const IconNavArrowUp48Line = createIcon(NavArrowUp, 48, "Line");
export const IconNavArrowUp64Line = createIcon(NavArrowUp, 64, "Line");
